// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/Image-Girl-Home.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.text-overflow__pb6bx {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-gradient__pYHM7 {
  background-image: -webkit-gradient(linear, 37.219838% 34.532506%, 36.425669% 93.178216%, from(#29cdff), to(#0a60ff), color-stop(0.37, #148eff));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.background-hover__DBn4j {
  transition: all 0.3s ease-out;
}
.background-hover__DBn4j:hover {
  background-color: #f9f9fc;
}
.imageGirl__B8HG9 {
  border: "0px solid";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.hometitle__wYlqX {
  color: #e62020 !important;
  letter-spacing: 2px;
  text-align: center;
  border: 0px solid;
  font-size: 30px !important;
  font-family: 'Noto Sans', sans-serif;
}
.homehubtxt__OQa8V {
  color: #272727;
  font-size: 18px;
  padding-left: 20px;
  padding-right: 20px;
}
.homehubtxt2__ywUEI {
  color: #272727;
  font-size: 12px;
  font-weight: bold;
  float: left;
  margin-left: 20px;
  text-align: center;
}
.homebtn__U78UA {
  margin-right: 16px;
}
.homedivider__H0XWZ {
  background: white;
  margin: 5px auto;
  border: 0.1em solid white;
  width: 70% !important;
}
@media (max-width: 992px) {
  .imageGirl__B8HG9 {
    background-image: unset;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #C1D5DC;
  }
  .hometitle__wYlqX {
    font-size: 22px !important;
    letter-spacing: 0px;
  }
  .homehubtxt__OQa8V {
    font-size: 17px;
  }
  .homehubtxt2__ywUEI {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Views/Home/Home.module.less","webpack://./src/Themes/mixin.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;ACO7F;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;ADLF;ACQA;EACE,+IAAA;EAQA,6BAAA;EACA,oCAAA;ADbF;ACgBA;EACE,6BAAA;ADdF;ACeE;EACE,yBAAA;ADbJ;AAhBA;EACE,mBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,yBAAA;AAkBF;AAfA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,oCAAA;AAiBF;AAdA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAgBF;AAdA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAgBF;AAdA;EACE,kBAAA;AAgBF;AAbA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAeF;AAZA;EAEE;IACE,uBAAA;IACA,4BAAA;IACA,sBAAA;IACA,yBAAA;EAaF;EAXA;IACE,0BAAA;IACA,mBAAA;EAaF;EAXA;IAEE,eAAA;EAYF;EATA;IAEE,eAAA;EAUF;AACF","sourcesContent":["@import '../../Themes/vars.less';\n\n\n.imageGirl{\n  border: \"0px solid\";\n  background-image: url(\"../../assets/img/Image-Girl-Home.jpg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-color: #464646;\n}\n\n.hometitle{\n  color: #e62020 !important;\n  letter-spacing: 2px;\n  text-align: center;\n  border: 0px solid;\n  font-size: 30px !important;\n  font-family: 'Noto Sans', sans-serif;\n}\n\n.homehubtxt{\n  color: #272727;\n  font-size: 18px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.homehubtxt2{\n  color: #272727;\n  font-size: 12px;\n  font-weight: bold;\n  float: left;\n  margin-left: 20px;\n  text-align: center;\n}\n.homebtn{\n  margin-right: 16px\n}\n\n.homedivider{\n  background: white;\n  margin: 5px auto;\n  border: 0.1em solid white;\n  width: 70% !important;\n}\n\n@media (max-width: 992px) {\n  \n  .imageGirl{\n    background-image: unset;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-color: #C1D5DC;\n  }\n  .hometitle{\n    font-size: 22px !important;\n    letter-spacing: 0px;\n  }\n  .homehubtxt{\n   \n    font-size: 17px;\n  \n  }\n  .homehubtxt2{\n\n    font-size: 12px;\n\n  }\n}","@import './default.less'; \n\n@dark-half: #494949;\n@purple: #d897eb;\n@shadow-1: 4px 4px 20px 0 rgba(0, 0, 0, 0.01);\n@shadow-2: 4px 4px 40px 0 rgba(0, 0, 0, 0.05);\n@transition-ease-in: all 0.3s ease-out;\n@transition-ease-out: all 0.3s ease-out;\n@ease-in: ease-in;\n\n.text-overflow {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.text-gradient {\n  background-image: -webkit-gradient(\n    linear,\n    37.219838% 34.532506%,\n    36.425669% 93.178216%,\n    from(#29cdff),\n    to(#0a60ff),\n    color-stop(0.37, #148eff)\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.background-hover {\n  transition: @transition-ease-in;\n  &:hover {\n    background-color: @hover-color;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text-overflow": `text-overflow__pb6bx`,
	"text-gradient": `text-gradient__pYHM7`,
	"background-hover": `background-hover__DBn4j`,
	"imageGirl": `imageGirl__B8HG9`,
	"hometitle": `hometitle__wYlqX`,
	"homehubtxt": `homehubtxt__OQa8V`,
	"homehubtxt2": `homehubtxt2__ywUEI`,
	"homebtn": `homebtn__U78UA`,
	"homedivider": `homedivider__H0XWZ`
};
export default ___CSS_LOADER_EXPORT___;
